import { BasePortal } from './BasePortal';

export class CrazyGamesPortal extends BasePortal {
	name = 'CrazyGamesPortal';
	autoLogin = true;
	hideMoreGames = true;
	hideSuggestions = false;
	hideReportBug = false;

	async init() {
		try {
			await import('https://sdk.crazygames.com/crazygames-sdk-v3.js');

			const sdk = globalThis.CrazyGames.SDK;
			await sdk.init();
		} catch (err) {
			console.error('failed to load crazygames', err);
		}

	}
	isCrazyGames() {
		if (typeof globalThis.CrazyGames === 'undefined') return false;
		if (!globalThis.CrazyGames.SDK) return false;
		if (globalThis.CrazyGames.SDK.environment === "disabled") {
			console.log('CrazyGames SDK is disabled');
			return false;
		}
		return true;
	}
	async load() {
		if (!this.isCrazyGames()) return;

		const data = {};
		try {
			data.userdata = await this.loadData();
			data.user = await this.loadUser();
		} catch (err) {
			console.warn('Failed to call CrazyGames SDK load:', err);
		}
		return data;
	}
	async save(data, forceSave) {
		if (!this.isCrazyGames()) {
			return;
		}

		const sdk = globalThis.CrazyGames.SDK;
		if (!sdk.data) return;

		sdk.data.setItem("userdata", JSON.stringify(data));

	}
	async delete() {
		if (!this.isCrazyGames()) {
			return;
		}
		const sdk = globalThis.CrazyGames.SDK;
		if (!sdk.data) return;

		sdk.data.clear();
	}
	async loadData() {
		if (!this.isCrazyGames()) {
			return null;
		}
		const sdk = globalThis.CrazyGames.SDK;
		if (!sdk.data) return null;

		//get userdata from crazygames storage - and get newest data
		const userdata_crazyGame_string = sdk.data.getItem('userdata');
		if (!userdata_crazyGame_string) {
			return null;
		}

		try {
			const portalUserdata = JSON.parse(userdata_crazyGame_string);
			return portalUserdata;
		} catch (err) {
			console.warn('Failed to parse CrazyGames userdata:', err);
			return null;
		}

	}
	async loadUser() {
		if (!this.isCrazyGames()) {
			return null;
		}

		const sdk = globalThis.CrazyGames.SDK;
		if (!sdk.data) return null;

		

		if (!sdk.user.isUserAccountAvailable) {
			return null;
		}

		const user = {};
		try {
			const userdetails = await sdk.user.getUser();

			// Add null check for userdetails
			if (!userdetails) {
				console.warn('CrazyGames getUser returned null/undefined');
				return null;
			}

			if (userdetails?.username) {
				user.name = userdetails.username;
				user.crazyGamesId = userdetails.username; //use username for now, not actual userid from crazy games, too many steps and higher risk of failure
			}
			if (userdetails?.profilePictureUrl) {
				user.avatar = userdetails.profilePictureUrl;
			}
		} catch (err) {
			console.warn('Failed to get CrazyGames user details:', err);
			return null;
		}

		////options #1 - Get or Create User ID
		////cascade login from most complicated to least complicated safe failing method
		////////// getting Crazy Game userid is disabled for now, it will slow the server down too much - Rely on auto created accounts for now and the local stoage and crazy games data restore.
		// // // //get userToken
		// // // try {
		// // //   const userToken = await window.CrazyGames.SDK.user.getUserToken();
		// // //   if (userToken) {
		// // //     const data = await this.accountJD.CrazyGameUserData(userToken);
		// // //     if (data) {
		// // //       if (data.id) userdata.crazyGamesId = data.id;
		// // //     }
		// // //   }
		// // // } catch (e) { }


		return user;
	}

	gameStart() {
		if (!this.isCrazyGames()) {
			return;
		}

		try {
			const sdk = globalThis.CrazyGames.SDK;
			sdk.game.gameplayStart();
		} catch (err) {
			console.warn('Failed to call gameplayStart:', err);
		}
	}

	gameStop() {
		if (!this.isCrazyGames()) {
			return;
		}

		try {
			const sdk = globalThis.CrazyGames.SDK;
			sdk.game.gameplayStop();
		} catch (err) {
			console.warn('Failed to call gameplayStop:', err);
		}
	}

	loadStart() {
		if (!this.isCrazyGames()) {
			return;
		}

		try {
			const sdk = globalThis.CrazyGames.SDK;
			sdk.game.loadingStart();
		} catch (err) {
			console.warn('Failed to call loadingStart:', err);
		}
	}

	loadStop() {
		if (!this.isCrazyGames()) {
			return;
		}

		try {
			const sdk = globalThis.CrazyGames.SDK;
			sdk.game.loadingStop();
		} catch (err) {
			console.warn('Failed to call loadingStop:', err);
		}
	}

}
